import styled, { css } from "styled-components";
import * as React from "react";
import { Timestamp } from "components/common";
import { relativeDifferenceDays } from "util/DateTime";
const Container = styled.div`
  display: flex;
  gap: 15px;
`;
const DaysCol = styled.div(
  ({ theme }) => `
  font-size: ${theme.fonts.size.huge};
  line-height: 1;
`
);
const DateAndTitleCol = styled.div`
  display: flex;
  flex-direction: column;
`;
const Date = styled.div`
  font-weight: bold;
`;
const Description = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const DateStat = ({ date, description }) => {
  const daysDifference = relativeDifferenceDays(date);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(DaysCol, null, daysDifference), /* @__PURE__ */ React.createElement(DateAndTitleCol, null, /* @__PURE__ */ React.createElement(Date, null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: date, format: "date" })), /* @__PURE__ */ React.createElement(Description, null, description)));
};
export default DateStat;
